import { loadLocaleFiles, setLocaleByCountryCode } from '@/i18n';
import { useDeviceSpecificationStore } from '../stores/deviceSpecificationStore';
import type { COUNTRY_CODE } from '@/utils/constants';

/**
 * Module-level singleton flags:
 * * Track if the locale watcher has been setup to avoid subscribe multiple times when navigate between modules
 * * Track if the locales have been loaded to avoid loading again
 */
let localeWatcherInitialized = false;
let localesLoaded = false;

export function loadCommissioningLocales() {
  if (localesLoaded) return;
  localesLoaded = true;

  loadLocaleFiles(import.meta.glob('./*.json', { eager: true, import: 'default' }));
}

/**
 * Setup a watcher on the device specification store to update the locale when the project country changes.
 */
export function setupCommissioningLocaleWatcher() {
  if (localeWatcherInitialized) return;
  localeWatcherInitialized = true;

  const deviceSpecificationStore = useDeviceSpecificationStore();
  const initialCountryCode = deviceSpecificationStore.solshareSite?.country;
  if (initialCountryCode) {
    setLocaleByCountryCode(initialCountryCode as COUNTRY_CODE);
  }

  deviceSpecificationStore.$subscribe((_mutation, state) => {
    if (state.solshareSite?.country) {
      // if the change includes changing the project country
      const countryCode = state.solshareSite.country;
      setLocaleByCountryCode(countryCode as COUNTRY_CODE);
    }
  });
}

// Test-only helper to reset module-level flags.
export function __resetLocaleWatcherForTest() {
  localeWatcherInitialized = false;
  localesLoaded = false;
}